import { Empty, IconFont, Image, Text } from '@byecode/ui'
import { timeDistance } from '@lighthouse/shared'
import QRCode from 'qrcode.react'
import React, { useState } from 'react'
import styled from 'styled-components'

import { useWxMiniProgramsAuthorizationResult } from '@/shared/reusable'

const SCxContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-size: var(--font-size-normal);
`

const SCxTips = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    background-color: var(--color-theme-2);
    color: var(--color-theme-7);
    border-radius: 4px;
    gap: 4px;
    font-size: var(--font-size-sm);
`
const SCxQrCode = styled.div`
    /* padding: 6px; */
    /* margin-bottom: 16px; */
    /* margin-top: 20px; */
    position: relative;
    width: 144px;
    height: 144px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 2px solid var(--color-gray-200);
    background: var(--color-white);
    overflow: hidden;
`

const SCxQrCodeContainer = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 24px;
`
const SCxImgThumbnail = styled.div`
    position: absolute;
    left: 4px;
    top: 4px;
    width: 132px;
    height: 132px;
    border-radius: 100%;
    background: var(--color-gray-100);
    overflow: hidden;
`

interface ProdQrcodeProps {
    isWxProgramsPublished?: boolean
    qrcode: string
}

export const ProdQrcode: React.FC<ProdQrcodeProps> = ({ qrcode, isWxProgramsPublished }) => {
    const { data: wxMiniProgramsAuthorization, update } = useWxMiniProgramsAuthorizationResult()
    const { releaseInfo } = wxMiniProgramsAuthorization || {}
    const [loading, setLoading] = useState(true)

    return (
        <SCxContent>
            {isWxProgramsPublished ? (
                <>
                    <SCxQrCodeContainer>
                        <SCxQrCode>
                            <Image src={qrcode} onLoad={() => setLoading(false)} />
                            {loading && <SCxImgThumbnail />}
                            {/* <QRCode size={133} value={qrcode ?? ''} renderAs="canvas" /> */}
                        </SCxQrCode>
                        <Text size={16} weight={500} color="var(--color-block)" lineHeight="24px" style={{ marginTop: 8 }}>
                            扫码查看小程序
                        </Text>
                        <Text lineHeight="20px" size={12} color="var(--color-gray-400)">
                            当更新发布应用，会同步更新正式版小程序
                        </Text>
                        <Text lineHeight="20px" size={12} color="var(--color-gray-400)">
                            {timeDistance(releaseInfo?.releaseUpdateTime ?? Date.now())} 更新
                        </Text>
                    </SCxQrCodeContainer>
                </>
            ) : (
                <Empty
                    icon={<IconFont type="Publish" color="var(--color-gray-400)" size={69} />}
                    description="提交微信审核，通过后会自动发布正式版"
                    style={{ margin: '20px 0 12px 0' }}
                />
            )}
        </SCxContent>
    )
}
